module.exports = __webpack_public_path__ + "img/image88.79cabd99.png";